/**
 * Hubtype component
 */
(function () {
    'use strict';

    var itxHubtypeCmp = {
        controller: itxHubtypeCmpCtrl,
        templateUrl: 'hubtype.component.html',
        bindings: {
            config: '<'
        }
    };

    itxHubtypeCmpCtrl.$inject = ['ItxHubtypeSvc', '$scope'];

    function itxHubtypeCmpCtrl(ItxHubtypeSvc, $scope) {
        var _this = this;

        _this.$onInit = function () {
            ItxHubtypeSvc.initWidget(_this.config);
        };

        /**
         * Al autenticar el usuario, actualizamos la información de Hybtype
         */
        $scope.$on('login:success', function () {
            // Actualizamos Hubtype con la información del usuario autenticado
            if (window.Botonic) {
                var userData = ItxHubtypeSvc.getDataFromUser();
                window.Botonic.updateUser(userData);
            }
        });
    }

    angular.module('itxApp.common').component('itxHubtype', itxHubtypeCmp);
})();
